import setupDeprecationWorkflow from 'ember-cli-deprecation-workflow';
/**
 * Docs: https://github.com/ember-cli/ember-cli-deprecation-workflow
 */
setupDeprecationWorkflow({
  /**
    false by default, but if a developer / team wants to be more aggressive about being proactive with
    handling their deprecations, this should be set to "true"
  */
  "throwOnUnhandled": false,
  "workflow": [
    /* ... handlers ... */
    /* to generate this list, run your app for a while (or run the test suite),
     * and then run in the browser console:
     *
     *    deprecationWorkflow.flushDeprecations()
     *
     * And copy the handlers here
     */
    /* example: */
    /* { handler: 'silence', matchId: 'template-action' }, */
    { /* TODO: Why does this handler not work? */
      "handler": "silence",
      "matchId": "deprecate-import--set-classic-decorator-from-ember"
    },
    {
      "handler": "silence",
      "matchId": "deprecate-import--proxy-mixin-from-ember"
    },
    {
      "handler": "silence",
      "matchId": "deprecate-import-router-dsl-from-ember"
    },
    {
      "handler": "silence",
      "matchId": "deprecate-import-onerror-from-ember"
    },
    {
      "handler": "silence",
      "matchId": "warp-drive.deprecate-tracking-package"
    },
    {
      "handler": "silence",
      "matchId": "deprecate-import-is-empty-from-ember"
    },
    {
      "handler": "silence",
      "matchId": "warp-drive:deprecate-legacy-request-methods"
    },
    {
      "handler": "silence",
      "matchId": "ember-concurrency.deprecate-wait-for-property"
    },
    {
      "handler": "silence",
      "matchId": "deprecate-import--is-destroying-from-ember"
    },
    {
      "handler": "silence",
      "matchId": "deprecate-import--is-destroyed-from-ember"
    },
    {
      "handler": "silence",
      "matchId": "deprecate-import-destroy-from-ember"
    },
    {
      "handler": "silence",
      "matchId": "deprecate-import--register-destructor-from-ember"
    },
    { /* This is coming from ember-concurrency. Should go away when we update to EC v5. */
      "handler": "silence",
      "matchId": "deprecate-import-env-from-ember"
    },
  ]
});
